import { asset } from "@/lib/api";
import { field } from "../formBits";
import { SourceChip } from "./trackBits";
import { FullSongActions } from "./FullSongActions";

const SECTIONS = [["works", "Works"], ["comics", "Comics"], ["timelapse", "Timelapses"], ["webtoons", "Webtoons"]];

const Pick = ({ id, label, current, queue, onPick }) => {
  const options = current && !queue.some((t) => t.id === current.id) ? [current, ...queue] : queue;
  return (
    <div className="space-y-2 bg-[#0B0C10] border border-[#F5A524]/15 p-2" data-testid={`section-track-${id}`}>
    <div className="flex items-center gap-3">
      <span className="w-24 shrink-0 font-display font-bold uppercase text-lg">{label}</span>
      <span className="w-10 h-10 shrink-0 bg-black border border-white/10">
        {current?.cover && <img src={asset(current.cover)} alt="" className="w-full h-full object-cover" />}
      </span>
      <select data-testid={`section-track-select-${id}`} value={current?.id || ""} onChange={(e) => onPick(options.find((t) => t.id === e.target.value) || null)}
        className={`${field} min-w-0 flex-1 py-2`}>
        <option value="">No song (keep playing the queue)</option>
        {options.map((t) => <option key={t.id} value={t.id}>{t.title}{t.artist ? ` — ${t.artist}` : ""}</option>)}
      </select>
      {current && <SourceChip t={current} />}
    </div>
    <FullSongActions id={id} current={current} onPick={onPick} />
    </div>
  );
};

export const SectionTracks = ({ s, set }) => {
  const queue = s.music_queue ?? [];
  const tracks = s.section_tracks ?? {};
  const pick = (id, t) => {
    const next = { ...tracks };
    if (t) next[id] = t; else delete next[id];
    set("section_tracks", next);
  };
  return (
    <div className="space-y-3 border-t border-[#F5A524]/15 pt-5" data-testid="section-soundtracks">
      <p className="font-mono text-xs tracking-[0.25em] text-[#F5A524]">03 — SECTION SOUNDTRACKS</p>
      <label className="flex items-center gap-3 cursor-pointer">
        <input data-testid="section-music-enabled-checkbox" type="checkbox" checked={!!s.section_music_enabled} onChange={(e) => set("section_music_enabled", e.target.checked)} className="w-4 h-4 accent-[#F5A524]" />
        <span className="font-mono text-xs tracking-[0.2em] text-zinc-300">SWITCH SONGS AS VISITORS SCROLL INTO A SECTION</span>
      </label>
      <p className="text-xs text-zinc-400">While a visitor is listening, the song changes when they scroll into a section, and the queue comes back when they leave it. If they haven't pressed play yet, they see a small "tap to play" prompt. Pick a song from your queue, or give a section a full-length song by pasting a YouTube link or uploading audio.</p>
      {s.section_music_enabled && (
        <div className="space-y-2">{SECTIONS.map(([id, label]) => <Pick key={id} id={id} label={label} current={tracks[id]} queue={queue} onPick={(t) => pick(id, t)} />)}</div>
      )}
    </div>
  );
};
